import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = {
  key: 1,
  class: "menu-bar"
}
const _hoisted_3 = { class: "right-suff" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { key: 1 }
const _hoisted_6 = { class: "action-list" }
const _hoisted_7 = { style: {"display":"flex"} }
const _hoisted_8 = {
  key: 0,
  class: "preview-item"
}
const _hoisted_9 = {
  key: 0,
  class: "preview-item"
}
const _hoisted_10 = {
  key: 0,
  class: "preview-item"
}
const _hoisted_11 = { class: "preview-list el-upload-list el-upload-list--picture-card" }
const _hoisted_12 = { class: "preview-item el-upload-list__item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_alert = _resolveComponent("el-alert")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_Delete = _resolveComponent("Delete")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_RegionPicker = _resolveComponent("RegionPicker")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_checkbox = _resolveComponent("el-checkbox")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.isMerchant)
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: _ctx.listType,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.listType) = $event)),
          onTabChange: _ctx.onTabChange
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_tab_pane, {
              label: "资质列表",
              name: 1
            }),
            _createVNode(_component_el_tab_pane, {
              label: "审核记录",
              name: 2
            })
          ]),
          _: 1
        }, 8, ["modelValue", "onTabChange"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(_component_el_menu, {
            "default-active": _ctx.activeIndex,
            mode: "horizontal",
            onSelect: _ctx.onNavChange
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_menu_item, { index: "1" }, {
                default: _withCtx(() => _cache[20] || (_cache[20] = [
                  _createTextVNode("自有模板")
                ])),
                _: 1
              }),
              _createVNode(_component_el_menu_item, { index: "2" }, {
                default: _withCtx(() => _cache[21] || (_cache[21] = [
                  _createTextVNode("自定义模板")
                ])),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["default-active", "onSelect"]),
          _createElementVNode("em", _hoisted_3, "当前品牌：" + _toDisplayString(_ctx.brandName), 1)
        ])),
    _withDirectives(_createVNode(_component_el_row, {
      gutter: 10,
      style: {"margin-top":"20px"}
    }, {
      default: _withCtx(() => [
        _withDirectives(_createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_input, {
              modelValue: _ctx.labelName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.labelName) = $event)),
              placeholder: "请输入模板名称",
              clearable: ""
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.activeIndex === '2']
        ]),
        _withDirectives(_createVNode(_component_el_col, { span: 6 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_select, {
              modelValue: _ctx.productId,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.productId) = $event)),
              placeholder: "请选择商品"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.productList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.title,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _: 1
        }, 512), [
          [_vShow, _ctx.activeIndex === '3']
        ]),
        _createVNode(_component_el_col, { span: 4 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_button, {
              type: "primary",
              onClick: _ctx.onAddLabel
            }, {
              default: _withCtx(() => _cache[22] || (_cache[22] = [
                _createTextVNode("添加")
              ])),
              _: 1
            }, 8, ["onClick"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512), [
      [_vShow, _ctx.activeIndex !== '1']
    ]),
    _createVNode(_component_el_table, {
      style: {"margin-top":"20px"},
      data: _ctx.tableData,
      "row-key": "id",
      border: "",
      "tree-props": {children: 'children', hasChildren: 'hasChildren'},
      "row-class-name": _ctx.rowClassName
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          prop: "name",
          label: "名称"
        }),
        (_ctx.listType != 2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 0,
              label: "状态"
            }, {
              default: _withCtx((scope) => [
                (scope.row.is_stale_dated==1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_4, "已过期"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(scope.row.is_stale_dated==0 ? '未上传' : '正常'), 1))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, {
          prop: "end_time",
          label: "过期时间"
        }, {
          default: _withCtx((scope) => [
            _createTextVNode(_toDisplayString(scope.row.long_time == 1 ? '长期' : (scope.row.end_time ? scope.row.end_time : '--')), 1)
          ]),
          _: 1
        }),
        (_ctx.listType == 2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 1,
              label: "审核状态"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(_ctx.CheckType[scope.row.status]), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (_ctx.listType == 2)
          ? (_openBlock(), _createBlock(_component_el_table_column, {
              key: 2,
              label: "审核意见"
            }, {
              default: _withCtx((scope) => [
                _createElementVNode("span", null, _toDisplayString(scope.row.msg || '--'), 1)
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_el_table_column, { label: "操作" }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.listType == 2)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 0,
                    class: "edit-btn",
                    onClick: ($event: any) => (_ctx.onShowRow(scope.row))
                  }, {
                    default: _withCtx(() => _cache[23] || (_cache[23] = [
                      _createTextVNode("资料管理")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : (_openBlock(), _createBlock(_component_el_tag, {
                    key: 1,
                    class: "edit-btn",
                    onClick: ($event: any) => (_ctx.onEdit(scope.row))
                  }, {
                    default: _withCtx(() => _cache[24] || (_cache[24] = [
                      _createTextVNode("资料管理")
                    ])),
                    _: 2
                  }, 1032, ["onClick"])),
              (!_ctx.isMerchant)
                ? (_openBlock(), _createBlock(_component_el_tag, {
                    key: 2,
                    class: "download-btn",
                    onClick: ($event: any) => (_ctx.onDownload(scope.row))
                  }, {
                    default: _withCtx(() => _cache[25] || (_cache[25] = [
                      _createTextVNode("打包下载")
                    ])),
                    _: 2
                  }, 1032, ["onClick"]))
                : _createCommentVNode("", true),
              _withDirectives(_createVNode(_component_el_tag, {
                class: "del-btn",
                onClick: ($event: any) => (_ctx.onDel(scope.row))
              }, {
                default: _withCtx(() => _cache[26] || (_cache[26] = [
                  _createTextVNode("删除")
                ])),
                _: 2
              }, 1032, ["onClick"]), [
                [_vShow, _ctx.activeIndex !== '1']
              ])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name"]),
    (!_ctx.isMerchant)
      ? (_openBlock(), _createBlock(_component_el_pagination, {
          key: 2,
          onCurrentChange: _ctx.onCurrentChange,
          "current-page": _ctx.currentPage,
          layout: "total, prev, pager, next, jumper",
          "page-size": _ctx.pageSize,
          total: _ctx.total
        }, null, 8, ["onCurrentChange", "current-page", "page-size", "total"]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      title: "资质完善",
      modelValue: _ctx.businessDialogVisible,
      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.businessDialogVisible) = $event)),
      "close-on-click-modal": false,
      "show-close": _ctx.is_contracts != 3,
      "z-index": 2000,
      "close-on-press-escape": false
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form, {
          model: _ctx.businessFormData,
          rules: _ctx.businessRules,
          ref: "businessForm",
          "label-width": "200",
          disabled: _ctx.businessFormDisabled
        }, {
          default: _withCtx(() => [
            (_ctx.listType == 1 && _ctx.hasCheckLog)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  class: "em-el-from-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_alert, {
                      title: "当前有正在审核中记录，不可重复提交",
                      type: "warning",
                      closable: false,
                      center: ""
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.CheckType[_ctx.businessFormData.status] === '驳回')
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 1,
                  class: "em-el-from-item"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_alert, {
                      title: `已驳回：${_ctx.businessFormData.msg}`,
                      type: "error",
                      closable: false,
                      center: ""
                    }, null, 8, ["title"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: "法人姓名：",
              prop: "id_name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.businessFormData.id_name,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.businessFormData.id_name) = $event)),
                  modelModifiers: { trim: true },
                  maxlength: "8",
                  placeholder: "请填写法人姓名"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "法人身份证号：",
              prop: "id_number"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.businessFormData.id_number,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.businessFormData.id_number) = $event)),
                  modelModifiers: { trim: true },
                  placeholder: "请填写法人身份证号"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_el_form_item, {
                label: "法人身份证：",
                prop: "idCard1"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_ctx.businessFormData.idCard1)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createVNode(_component_el_image, {
                            src: _ctx.businessFormData.idCard1,
                            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.previewList = [_ctx.businessFormData.idCard1])),
                            "preview-src-list": _ctx.previewList,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 3000
                          }, null, 8, ["src", "preview-src-list"]),
                          (_ctx.listType != 2)
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 0,
                                class: "icon",
                                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onRemoveCard(1)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock(_component_el_upload, {
                          key: 1,
                          class: "idCard-upload",
                          accept: "image/png,image/jpg,image/jpeg",
                          action: "uploadUrl",
                          "before-upload": file => _ctx.onBeforeUpload(file),
                          "http-request": file => _ctx.onUploadSuccess(file, 1),
                          "list-type": "picture-card",
                          "show-file-list": false
                        }, {
                          default: _withCtx(() => _cache[27] || (_cache[27] = [
                            _createElementVNode("div", { class: "el-upload__text" }, [
                              _createElementVNode("img", {
                                style: {"width":"100%"},
                                src: "https://image-oss.dangaoss.cn/common/common_20250319163119_533.jpg"
                              })
                            ], -1)
                          ])),
                          _: 1
                        }, 8, ["before-upload", "http-request"]))
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                class: "no-label-el-form-item",
                prop: "idCard2"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", null, [
                    (_ctx.businessFormData.idCard2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createVNode(_component_el_image, {
                            src: _ctx.businessFormData.idCard2,
                            onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.previewList = [_ctx.businessFormData.idCard2])),
                            "preview-src-list": _ctx.previewList,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 3000
                          }, null, 8, ["src", "preview-src-list"]),
                          (_ctx.listType != 2)
                            ? (_openBlock(), _createBlock(_component_el_icon, {
                                key: 0,
                                class: "icon",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onRemoveCard(2)))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_Delete)
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true)
                        ]))
                      : (_openBlock(), _createBlock(_component_el_upload, {
                          key: 1,
                          class: "idCard-upload",
                          accept: "image/png,image/jpg,image/jpeg",
                          action: "uploadUrl",
                          "before-upload": file => _ctx.onBeforeUpload(file),
                          "http-request": file => _ctx.onUploadSuccess(file, 2),
                          "list-type": "picture-card",
                          "show-file-list": false
                        }, {
                          default: _withCtx(() => _cache[28] || (_cache[28] = [
                            _createElementVNode("div", { class: "el-upload__text" }, [
                              _createElementVNode("img", {
                                style: {"width":"100%"},
                                src: "https://image-oss.dangaoss.cn/common/common_20250319163120_99.jpg"
                              })
                            ], -1)
                          ])),
                          _: 1
                        }, 8, ["before-upload", "http-request"]))
                  ])
                ]),
                _: 1
              })
            ]),
            _createVNode(_component_el_form_item, {
              label: "选择：",
              prop: "selectRegion"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_RegionPicker, {
                  modelValue: _ctx.businessFormData.selectRegion,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.businessFormData.selectRegion) = $event)),
                  showDistrict: false
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "户籍地址：",
              prop: "registered_address"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  style: {"width":"490px"},
                  modelValue: _ctx.businessFormData.registered_address,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.businessFormData.registered_address) = $event)),
                  modelModifiers: { trim: true },
                  type: "textarea",
                  row: 3,
                  placeholder: "请填户籍地址"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "营业执照：",
              prop: "business_license"
            }, {
              default: _withCtx(() => [
                (_ctx.businessFormData.business_license)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_ctx.getFileSuffix(_ctx.businessFormData.business_license)==='pdf')
                        ? (_openBlock(), _createBlock(_component_el_link, {
                            key: 0,
                            href: _ctx.businessFormData.business_license,
                            target: "_blank"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_el_image, {
                                src: "//image-oss.dangaoss.cn/common/common_20230704142716_83.png",
                                fit: "scale-down",
                                "z-index": 3000
                              })
                            ]),
                            _: 1
                          }, 8, ["href"]))
                        : (_openBlock(), _createBlock(_component_el_image, {
                            key: 1,
                            src: _ctx.businessFormData.business_license,
                            onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.previewList = [_ctx.businessFormData.business_license])),
                            "preview-src-list": _ctx.previewList,
                            fit: "scale-down",
                            "hide-on-click-modal": "",
                            "append-to-body": "",
                            "z-index": 3000
                          }, null, 8, ["src", "preview-src-list"])),
                      (_ctx.listType != 2)
                        ? (_openBlock(), _createBlock(_component_el_icon, {
                            key: 2,
                            class: "icon",
                            onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.onRemoveCard(3)))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_Delete)
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createBlock(_component_el_upload, {
                      key: 1,
                      class: "el-upload-list__item empty-item",
                      accept: "image/png,image/jpg,image/jpeg",
                      action: "uploadUrl",
                      "before-upload": file => _ctx.onBeforeUpload(file),
                      "http-request": file => _ctx.onUploadSuccess(file, 3),
                      "list-type": "picture-card",
                      "show-file-list": false
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_icon, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_Plus)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["before-upload", "http-request"]))
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "过期时间：" }, {
              default: _withCtx(() => [
                (_ctx.businessFormDisabled && _ctx.businessFormData.long_time == '0' || !_ctx.businessFormDisabled)
                  ? (_openBlock(), _createBlock(_component_el_date_picker, {
                      key: 0,
                      style: {"width":"190px"},
                      type: "date",
                      disabled: _ctx.businessFormDisabled && _ctx.businessFormData.long_time == '0' || !_ctx.businessFormDisabled && _ctx.businessFormData.long_time == '1',
                      "disabled-date": _ctx.disabledStartDate,
                      modelValue: _ctx.businessFormData.end_time,
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.businessFormData.end_time) = $event)),
                      placeholder: "请选择过期时间",
                      "value-format": "YYYY-MM-DD"
                    }, null, 8, ["disabled", "disabled-date", "modelValue"]))
                  : _createCommentVNode("", true),
                (_ctx.businessFormDisabled && _ctx.businessFormData.long_time == '1' || !_ctx.businessFormDisabled)
                  ? (_openBlock(), _createBlock(_component_el_checkbox, {
                      key: 1,
                      style: {"margin-left":"20px"},
                      modelValue: _ctx.businessFormData.long_time,
                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.businessFormData.long_time) = $event)),
                      label: "长期",
                      size: "large",
                      "true-value": 1,
                      "false-value": 0,
                      onChange: _ctx.onLongTimeChange
                    }, null, 8, ["modelValue", "onChange"]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            (!_ctx.isMerchant)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 2,
                  label: "到期提醒："
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_switch, {
                      modelValue: _ctx.msgStatus,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.msgStatus) = $event))
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            (_ctx.listType == 1 || _ctx.listType == 2 && _ctx.CheckType[_ctx.businessFormData.status] === '驳回')
              ? (_openBlock(), _createBlock(_component_el_form_item, { key: 3 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      type: "primary",
                      onClick: _ctx.onSaveMsg
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.isMerchant ? '提交审核' : '保存'), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["model", "rules", "disabled"])
      ]),
      _: 1
    }, 8, ["modelValue", "show-close"]),
    _createVNode(_component_el_dialog, {
      title: "资质完善",
      modelValue: _ctx.dialogVisible,
      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.dialogVisible) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_form_item, { label: "资质图片：" }, {
          default: _withCtx(() => [
            _createElementVNode("ul", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.previewList, (item, index) => {
                return (_openBlock(), _createElementBlock("div", { key: index }, [
                  _createElementVNode("li", _hoisted_12, [
                    (_ctx.getFileSuffix(item)==='pdf')
                      ? (_openBlock(), _createBlock(_component_el_link, {
                          key: 0,
                          href: item,
                          target: "_blank"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_image, {
                              src: "//image-oss.dangaoss.cn/common/common_20230704142716_83.png",
                              fit: "scale-down",
                              "z-index": 3000
                            })
                          ]),
                          _: 2
                        }, 1032, ["href"]))
                      : (_openBlock(), _createBlock(_component_el_image, {
                          key: 1,
                          src: item,
                          "preview-src-list": _ctx.previewList,
                          "initial-index": index,
                          fit: "scale-down",
                          "hide-on-click-modal": "",
                          "append-to-body": "",
                          "z-index": 3000
                        }, null, 8, ["src", "preview-src-list", "initial-index"])),
                    (_ctx.listType != 2)
                      ? (_openBlock(), _createBlock(_component_el_icon, {
                          key: 2,
                          class: "icon",
                          onClick: ($event: any) => (_ctx.onRemove(index, item))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_Delete)
                          ]),
                          _: 2
                        }, 1032, ["onClick"]))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode(_component_el_link, {
                    class: "file-name",
                    type: "primary",
                    underline: false,
                    href: item,
                    target: "_blank"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(((item.split('/'))[item.split('/').length-1]).split('?')[0]), 1)
                    ]),
                    _: 2
                  }, 1032, ["href"])
                ]))
              }), 128)),
              (_ctx.listType != 2)
                ? (_openBlock(), _createBlock(_component_el_upload, {
                    key: 0,
                    class: "el-upload-list__item",
                    ref: "uploadRef",
                    accept: "image/png,image/jpg,image/jpeg,application/pdf",
                    action: `${ _ctx.isMerchant ? '/api/cake_api/setOssImg' : '/api/cake/setOssImg'}?brand_id=${_ctx.brandId}&contracts_id=${_ctx.labelId}&mold_id=${_ctx.moldId}&user_id=${_ctx.store.state.user.userInfo.id}`,
                    "before-upload": _ctx.onBeforeUpload,
                    "on-success": _ctx.uploadSuccess,
                    "file-list": _ctx.fileList,
                    "show-file-list": false,
                    multiple: "",
                    "list-type": "picture-card"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_icon, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_Plus)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["action", "before-upload", "on-success", "file-list"]))
                : _createCommentVNode("", true)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_form, {
          inline: true,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            (_ctx.listType == 2 && _ctx.rejectMsg)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "驳回原因：",
                  style: {"width":"100%"}
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "textarea",
                      value: _ctx.rejectMsg,
                      disabled: ""
                    }, null, 8, ["value"])
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  (_ctx.listType != 2)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "过期时间："
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_date_picker, {
                            modelValue: _ctx.validDate,
                            "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.validDate) = $event)),
                            placeholder: "请选择过期时间",
                            "value-format": "YYYY-MM-DD"
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (!_ctx.isMerchant)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 1,
                        label: "到期提醒：",
                        style: {"margin-left":"20px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_switch, {
                            modelValue: _ctx.msgStatus,
                            "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.msgStatus) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.listType != 2)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 2,
                        style: {"margin-left":"50px"}
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_button, {
                            type: "primary",
                            size: "small",
                            onClick: _ctx.onSaveMsg
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.isMerchant ? '提交审核' : '保存'), 1)
                            ]),
                            _: 1
                          }, 8, ["onClick"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ], 64))
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}